import { render, staticRenderFns } from "./Teasers.vue?vue&type=template&id=bb548aee"
import script from "./Teasers.vue?vue&type=script&lang=js"
export * from "./Teasers.vue?vue&type=script&lang=js"
import style0 from "./Teasers.vue?vue&type=style&index=0&id=bb548aee&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,AnimationCustomFadeIn: require('/vercel/path0/components/elements/Animations/CustomFadeIn.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
